import { CommonModule } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { PromotionsService } from '../promotions.service';

/**
 * "See Available Promotions" entry point (DEV-9447).
 *
 * Renders only when the cart-promotions flow is enabled and the order has cart
 * promotions. Reused by the side cart and the order summary page so the
 * experience is identical across surfaces and easy to propagate per client.
 *
 * Use `[compact]="true"` in narrow surfaces (e.g. the side cart) for a tighter
 * single-purpose button.
 */
@Component({
  selector: 'app-available-promotions-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './available-promotions-button.component.html',
  styleUrl: './available-promotions-button.component.scss',
})
export class AvailablePromotionsButtonComponent {
  promotionsService = inject(PromotionsService);

  /** Tighter layout for narrow containers like the side cart. */
  compact = input<boolean>(false);

  openModal(): void {
    this.promotionsService.openPromotionsModal();
  }
}
